import { render, staticRenderFns } from "./shop_index_adv.vue?vue&type=template&id=7b742365&scoped=true&"
import script from "./shop_index_adv.vue?vue&type=script&lang=js&"
export * from "./shop_index_adv.vue?vue&type=script&lang=js&"
import style0 from "./shop_index_adv.vue?vue&type=style&index=0&id=7b742365&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b742365",
  null
  
)

export default component.exports